import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MerchantParkingListComponent } from './merchant-parking-list/merchant-parking-list.component'
import { MerchantParkingTypeComponent } from './merchant-parking-type/merchant-parking-type.component'
import { RouterModule } from '@angular/router'
import { MerchantParkingCreateComponent } from './merchant-parking-create/merchant-parking-create.component'
import { ReactiveFormsModule } from '@angular/forms'
import { CoreModule } from '../../shared/core/core.module'
import { ButtonsModule } from 'ngx-bootstrap/buttons'
import { MediaModule } from '../../shared/media/media.module'
import { MerchantBankingDetailsModule } from '../merchant-banking-details/merchant-banking-details.module'
import { AutosizeModule } from 'ngx-autosize'
import { ParkingModule } from '../../shared/parking/parking.module'

@NgModule({
    declarations: [MerchantParkingListComponent, MerchantParkingTypeComponent, MerchantParkingCreateComponent],
    exports: [MerchantParkingListComponent, MerchantParkingTypeComponent, MerchantParkingCreateComponent],
    imports: [CommonModule, RouterModule, ReactiveFormsModule, CoreModule, ButtonsModule, MediaModule, MerchantBankingDetailsModule, AutosizeModule, ParkingModule],
})
export class MerchantParkingModule {}
